<template lang="html">
  <div id="d-page-template-1">

    <!-- <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section> -->

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2 class="txt-breadcrumb">
            <span>Capacitaciones</span>
            {{row.name}}
          </h2>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <div class="box-results">

        <div class="card">
          <div class="tabs">
            <div class="tab-content">
              <div class="post-template-s5 w-extra detail-page">
                <!-- <div class="box-extra-content">
                  <div class="box-bubbles">
                    <span class="bubble green">Certificado</span>
                  </div>

                  <div class="box-txt">
                    <span class="date">12/MAYO/2023 - 16/MAYO/2023</span>
                  </div>
                </div> -->

                <div class="box-main-content">
                  <div class="box-top">
                    <div class="col-12 col-title">
                      <h5 class="title">{{row.name}}</h5>
                    </div>

                    <!-- <div class="col-12 col-location">
                      <h5 class="f-w-400 subtitle">Impartido por: Alexis Trujillo Cervantes, Psicologo.</h5>
                    </div> -->
                  </div>

                  <div class="mt-0 box-info">
                    <div class="mt-4 box-long-descr">

                      <div class="descr" v-html="row.description"></div>
                    </div>
                  </div>

                  <!-- <div class="box-actions">
                    <a class="btn btn-s1 bg-red btn-apply">Postularme</a>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },
      id:null,
      row:{},

    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRow(){
      axios.get(tools.url("/api/trainings/"+this.id)).then((response)=>{
          this.row = response.data;
      }).catch(()=>{});
    }
  },
  mounted(){
    this.id=this.$route.params.id;
      this.getRow();
  }
}
</script>
